import { Dialog as DialogMui } from '@mui/material';
import { styled } from '@mui/material/styles';

import { DialogProps } from './Dialog';

export const DialogStyled = styled(DialogMui)<DialogProps>(({ width }) => ({
  '.MuiBackdrop-root': {
    transition: 'none !important',
  },
  '.MuiPaper-root': {
    overflowY: 'auto',
    borderRadius: '8px',
  },
  ...(width && {
    '& .MuiDialog-paper': {
      minWidth: width,
    },
  }),
}));
